import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { StoreSettingUtil } from '../utils/store-setting-util';

import { StoreUtils } from '../utils/store-utils';

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {
  private currencySubject = new Subject<any>();
  private static displayCurrency: string = '';

  constructor() {
    if (!CurrencyService.displayCurrency) {
      const currency = StoreUtils.getStoreCurrency();
      if (currency && currency !== 'undefined') {
        CurrencyService.displayCurrency = currency;
      } else {
        const interval = setInterval(() => {
          const currentCurrency = StoreUtils.getStoreCurrency();
          if (currentCurrency && currentCurrency !== 'undefined') {
            CurrencyService.displayCurrency = currentCurrency;
            clearInterval(interval);
          }
        }, 500);

        // Safety timeout: default to USD if no currency found after 5 seconds
        setTimeout(() => {
          if (!CurrencyService.displayCurrency) {
            CurrencyService.displayCurrency = 'USD';
          }
          clearInterval(interval);
        }, 5000);
      }
    }
  }

  onChangeCurrency(currency: string) {
    CurrencyService.displayCurrency = currency;
    this.currencySubject.next({ currency: currency });
  }

  onGetCurrency(): Observable<any> {
    return this.currencySubject.asObservable();
  }

  refreshCurrencyFromStore() {
    const currency = StoreUtils.getStoreCurrency();
    if (currency && currency !== 'undefined') {
      this.onChangeCurrency(currency);
    }
  }

  getCurrenciesDisplay(): string[] {
    const exchange = StoreSettingUtil.getCurrencyExchange();
    if (!exchange) {
      return ['USD'];
    }

    if (exchange.from === 'USD' && exchange.to === 'USD') {
      return ['USD'];
    }

    return [exchange.from, exchange.to];
  }

  static isDisplayCurrencyUSD(): boolean {
    if (!this.displayCurrency) {
      const currency = StoreUtils.getStoreCurrency();
      if (currency && currency !== 'undefined') {
        this.displayCurrency = currency;
      } else {
        return true;
      }
    }
    return this.displayCurrency === 'USD';
  }

  static isDisplayCurrencyKHR(): boolean {
    if (!this.displayCurrency) {
      const currency = StoreUtils.getStoreCurrency();
      if (currency && currency !== 'undefined') {
        this.displayCurrency = currency;
      } else {
        return false;
      }
    }
    return this.displayCurrency === 'KHR';
  }

  static getDisplayCurrency(): string {
    if (!this.displayCurrency) {
      const currency = StoreUtils.getStoreCurrency();
      if (currency && currency !== 'undefined') {
        this.displayCurrency = currency;
      } else {
        return 'USD';
      }
    }
    return this.displayCurrency;
  }
}
